<template>
  <div class="race-manager-page">
    <van-nav-bar title="中长跑发令与成绩管理" fixed placeholder />

    <div class="control-panel">
      <div class="panel-header">
        <span class="title">当前项目：中长跑 (800米/1000米)</span>
        <van-switch v-model="isProjectOpen" size="24px" active-color="#07c160" @change="toggleProject" />
      </div>
      <div class="panel-desc">
        状态：<van-tag :type="isProjectOpen ? 'success' : 'danger'">{{ isProjectOpen ? '已开启，可发令' : '已关闭，不可测试' }}</van-tag>
      </div>
    </div>

    <div class="command-zone" v-if="isProjectOpen">
      <van-field
        readonly
        clickable
        name="picker"
        :value="currentGroup"
        label="当前测试组"
        placeholder="点击选择起跑组别"
        @click="showGroupPicker = true"
      />
      <van-popup v-model="showGroupPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="groupOptions"
          @confirm="onConfirmGroup"
          @cancel="showGroupPicker = false"
        />
      </van-popup>

      <div class="gun-box">
        <div v-if="raceState === 'idle'">
          <van-button type="danger" round class="gun-btn" @click="startCountdown">
            <span class="gun-text">准备发令</span>
          </van-button>
        </div>
        <div v-else-if="raceState === 'countdown'" class="countdown-display">
          <span class="count-num">{{ countdownNum }}</span>
        </div>
        <div v-else-if="raceState === 'running'" class="running-display">
          <van-loading type="spinner" color="#ee0a24" size="24px" />
          <span class="running-text">比赛进行中...</span>
          <van-button type="warning" size="small" round plain @click="stopRace">强行中止</van-button>
        </div>
      </div>
    </div>

    <div class="records-container">
      <van-tabs v-model="activeTab" sticky offset-top="46px" color="#1989fa">
        <van-tab title="本组实时成绩">
          <div class="record-list" v-if="currentRecords.length > 0">
            <van-cell-group inset>
              <van-cell v-for="item in currentRecords" :key="item.id" :title="item.name" :label="`学号: ${item.studentNo}`">
                <template #right-icon>
                  <div class="score-display">
                    <van-tag v-if="item.status === 'running'" type="primary" plain>奔跑中</van-tag>
                    <span v-else class="score-text text-danger font-bold">{{ item.score }}</span>
                  </div>
                </template>
              </van-cell>
            </van-cell-group>
          </div>
          <van-empty v-else description="暂无本组成绩，请先发令" />
        </van-tab>
        <van-tab title="历史测试记录">
          <div class="record-list">
            <van-cell-group inset>
              <van-cell title="张明" label="初三(1)班 - 1000米跑" value="3分15秒" />
              <van-cell title="李华" label="初三(1)班 - 1000米跑" value="3分42秒" />
              <van-cell title="王芳" label="初二(2)班 - 800米跑" value="3分20秒" />
            </van-cell-group>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RaceCommandManager',
  data() {
    return {
      isProjectOpen: false, // 项目是否开启
      showGroupPicker: false,
      currentGroup: '初三(1)班 - 第1组 (男生1000米)',
      groupOptions: ['初三(1)班 - 第1组 (男生1000米)', '初三(1)班 - 第2组 (女生800米)', '初二(3)班 - 第1组 (男生1000米)'],
      
      raceState: 'idle', // idle: 空闲, countdown: 倒计时, running: 比赛中
      countdownNum: 3,
      timer: null,

      activeTab: 0,
      currentRecords: [], // 本组人员及成绩
    };
  },
  methods: {
    toggleProject(val) {
      if (!val && this.raceState !== 'idle') {
        this.$toast('比赛进行中，无法关闭项目！');
        this.isProjectOpen = true; // 强制弹回
        return;
      }
      this.$toast(val ? '800/1000米终端通道已开启' : '项目已关闭，禁止终端上传成绩');
    },
    onConfirmGroup(value) {
      this.currentGroup = value;
      this.showGroupPicker = false;
      this.currentRecords = []; // 切换组别清空成绩
      this.raceState = 'idle';
    },
    // 1. 发起倒计时
    startCountdown() {
      this.raceState = 'countdown';
      this.countdownNum = 3;
      this.timer = setInterval(() => {
        this.countdownNum--;
        if (this.countdownNum === 0) {
          clearInterval(this.timer);
          this.fireGun(); // 开枪起跑
        }
      }, 1000);
    },
    // 2. 发令开枪，比赛开始 (生成初始人员名单)
    fireGun() {
      this.raceState = 'running';
      this.$toast.success('发令成功，开始计时！');
      // 模拟生成奔跑中的学生数据
      this.currentRecords = [
        { id: 1, name: '陈子涵', studentNo: '2023001', status: 'running', score: '' },
        { id: 2, name: '刘小虎', studentNo: '2023002', status: 'running', score: '' },
        { id: 3, name: '赵铁柱', studentNo: '2023003', status: 'running', score: '' }
      ];

      // 模拟硬件终端陆续回传成绩 (展示数据变动)
      setTimeout(() => this.recordFinish(1, "3'12''"), 3000); // 3秒后第一个人冲线(模拟)
      setTimeout(() => this.recordFinish(2, "3'35''"), 5000);
      setTimeout(() => {
        this.recordFinish(3, "4'05''");
        this.raceState = 'idle'; // 全员完赛，重置状态
        this.$toast('本组全员完赛！');
      }, 7000);
    },
    // 3. 记录冲线成绩
    recordFinish(id, timeStr) {
      const student = this.currentRecords.find(s => s.id === id);
      if (student) {
        student.status = 'finished';
        student.score = timeStr;
      }
    },
    // 强制终止
    stopRace() {
      this.$dialog.confirm({ title: '警告', message: '确定强行中止本次测验吗？已产生的成绩将被清空。' })
        .then(() => {
          this.raceState = 'idle';
          this.currentRecords = [];
          this.$toast('测验已中止');
        }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.race-manager-page {
  background-color: #f7f8fa;
  min-height: 100vh;
}
.control-panel {
  background: #fff;
  padding: 16px;
  margin-bottom: 12px;
}
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
}
.panel-desc {
  margin-top: 10px;
  font-size: 13px;
  color: #646566;
}
.command-zone {
  background: #fff;
  padding-bottom: 20px;
  margin-bottom: 12px;
}
.gun-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 140px;
}
.gun-btn {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  box-shadow: 0 4px 15px rgba(238, 10, 36, 0.4);
}
.gun-text {
  font-size: 18px;
  font-weight: bold;
}
.countdown-display .count-num {
  font-size: 72px;
  font-weight: bold;
  color: #ee0a24;
}
.running-display {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.running-text {
  font-size: 16px;
  color: #ee0a24;
  margin: 12px 0;
  font-weight: bold;
}
.record-list {
  padding: 12px 0;
}
.score-text {
  font-size: 16px;
}
.font-bold { font-weight: bold; }
.text-danger { color: #ee0a24; }
</style>